import { AlertCircle, ArrowRight } from "lucide-react";

const ProblemSection = () => {
  const symptoms = [
    "Persistent lower belly bulge",
    "Weak core strength",
    "Back pain",
    "Poor posture",
    "Urinary leakage",
  ];

  const scrollToBooking = () => {
    document.querySelector("#booking")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="section-spacing bg-white" data-testid="problem-section">
      <div className="section-container">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            {/* Hindi Hook */}
            <p className="text-xl md:text-2xl text-blue-700 font-medium mb-4 italic" data-testid="problem-hook">
              "Delivery ke baad bhi tummy bahar aa raha hai?"
            </p>

            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-6" data-testid="problem-headline">
              It may not be just weight gain.
            </h2>

            <div className="bg-pink-50 border-l-4 border-blue-600 p-6 rounded-r-xl mb-8" data-testid="problem-explanation">
              <p className="text-stone-700 text-lg">
                You may be suffering from <strong className="text-blue-800">Diastasis Recti</strong> – a separation of abdominal muscles after pregnancy that affects millions of women.
              </p>
            </div>

            {/* Symptoms */}
            <h3 className="text-xl font-bold text-blue-900 mb-4">Common Symptoms:</h3>
            <ul className="space-y-3 mb-8" data-testid="symptom-list">
              {symptoms.map((symptom, index) => (
                <li key={index} className="flex items-center gap-3">
                  <span className="w-6 h-6 bg-pink-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="w-2 h-2 bg-blue-600 rounded-full"></span>
                  </span>
                  <span className="text-stone-700">{symptom}</span>
                </li>
              ))}
            </ul>

            {/* Warning */}
            <div className="flex items-start gap-3 bg-amber-50 border border-amber-200 p-4 rounded-xl" data-testid="problem-warning">
              <AlertCircle className="text-amber-600 flex-shrink-0 mt-0.5" size={20} />
              <div>
                <p className="text-stone-700">
                  <strong className="text-amber-800">Most women ignore it.</strong><br />
                  But untreated Diastasis Recti can worsen over time, leading to chronic pain and complications.
                </p>
              </div>
            </div>

            {/* CTA */}
            <button
              onClick={scrollToBooking}
              className="mt-8 inline-flex items-center gap-2 text-blue-700 font-semibold hover:text-blue-800 transition-colors group"
              data-testid="problem-cta"
            >
              Get first FREE Expert Assessment
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </button>
          </div>

          {/* Visual */}
          <div className="relative">
            <div className="bg-gradient-to-br from-pink-100 to-blue-100 rounded-3xl p-8 lg:p-12">
              <img
                src="https://images.pexels.com/photos/5794058/pexels-photo-5794058.jpeg"
                alt="Physiotherapy treatment"
                className="rounded-2xl shadow-lg w-full"
                data-testid="problem-image"
              />

              {/* Stat Card */}
              <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl p-6 shadow-xl" data-testid="problem-stat-card">
                <p className="text-4xl font-bold text-blue-700">60%</p>
                <p className="text-sm text-stone-600">of women develop<br />Diastasis Recti<br />during pregnancy</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
